<template>
    <div class='graph-filter'>
        <div class="row">
            <div class="col-12">
                <el-card class="box-card" v-if="loaded === true">
                    <div class="row mobile-center">
                        <div class="col-xl-8 col-12 filter-left">
                            <el-select
                                v-model="managers"
                                filterable
                                :clearable=true
                                multiple
                                collapse-tags
                                placeholder="Filter managers"
                                @visible-change="managerSelectChange($event)"
                                @change="checkManagerSelect($event)"
                                v-if="$route.name.includes('magazine') === false">
                                <el-option
                                    label="All managers"
                                    value="all">
                                </el-option>
                                <el-option
                                    v-for="item in $store.getters['general/getStoreInterests']"
                                    :key="item.user_id"
                                    :label="item.user_name"
                                    :value="item.user_id">
                                </el-option>
                            </el-select>
                            <el-select
                                v-model="stores"
                                filterable
                                :clearable=true
                                multiple
                                collapse-tags
                                class="margin-left-xl"
                                placeholder="Filter stores"
                                @visible-change="storeSelectChange($event)"
                                @change="checkSelect($event)">
                                <el-option
                                    label="All stores"
                                    value="all">
                                </el-option>
                                <el-option
                                    label="No stores"
                                    value="none">
                                </el-option>
                                <el-option
                                    v-for="item in $store.getters['general/getStores']"
                                    :key="item.store_id"
                                    :label="item.store_name"
                                    :value="item.store_id">
                                </el-option>
                            </el-select>
                            <el-select v-if="$route.name.includes('contracts') === false && $route.name.includes('productivity') === false" v-model="period" placeholder="Period" class="period-select margin-left-xl">
                                <el-option
                                    v-for="item in ['Week', 'Month', 'Quarter']"
                                    :key="item"
                                    :label="item"
                                    :value="item">
                                </el-option>
                            </el-select>
                            <!-- <el-select v-if="$route.name.includes('workforce')" v-model="periodWorkforce" placeholder="Period" class="period-select margin-left-xl">
                                <el-option
                                    v-for="item in ['Week', 'Month', 'Quarter']"
                                    :key="item"
                                    :label="item"
                                    :value="item">
                                </el-option>
                            </el-select> -->
                        </div>
                        <div class="col-xl-4 col-12 filter-right">
                            <el-input-number v-if="$route.name.includes('contracts') === false && $route.name.includes('productivity') === false" v-model="numberOfPeriods" :step="8" :min="8" :max="24" label="Number of periods"></el-input-number>
                            <el-radio-group v-model="timePeers" size="medium" class="vertical-center switch-right ml-5-howrly" v-if="$route.name.includes('workforce')">
                                <el-radio-button label="Time"></el-radio-button>
                                <el-radio-button label="Peers"></el-radio-button>
                            </el-radio-group>

                            <!-- <el-radio-group v-model="productivitySwitch" size="medium" class="vertical-center switch-right ml-5-howrly" v-if="$route.name.includes('productivity')">
                                <el-radio-button label="AOV"></el-radio-button>
                                <el-radio-button label="Conv"></el-radio-button>
                                <el-radio-button label="ROI"></el-radio-button>
                                <el-radio-button label="Prod"></el-radio-button>
                            </el-radio-group> -->
                        </div>
                    </div>
                </el-card>
                <el-card class="box-card" v-else style="height: 80px;">
                    <div class="card-body no-padding">
                    </div>
                </el-card>
            </div>
        </div>
    </div>
</template>

<script>
var debounce = require('debounce')
export default {
    props: ['parent'],
    data () {
        return {
            loaded: false,
            stores: [],
            managers: [],
            firstLoad: true,
            loading: false
        }
    },
    components: {
    },
    computed: {
        contractsSwitch: {
            get () {
                return this.$store.state.graphFilter.contractsSwitch
            },
            set (value) {
                this.$store.commit('graphFilter/UPDATE_CONTRACTS_SWITCH', value)
                this.$emit('filterChanged')
            }
        },
        productivitySwitch: {
            get () {
                return this.$store.state.graphFilter.productivitySwitch
            },
            set (value) {
                this.$store.commit('graphFilter/UPDATE_PRODUCTIVITY_SWITCH', value)
                this.$emit('filterChanged')
            }
        },
        period: {
            get () {
                let period = this.$store.state.graphFilter.period
                return period.charAt(0).toUpperCase() + period.slice(1)
            },
            set (value) {
                this.$store.commit('graphFilter/UPDATE_PERIOD', value.toLowerCase())
                this.$emit('filterChanged')
            }
        },
        numberOfPeriods: {
            get () {
                return this.$store.state.graphFilter.numberOfPeriods
            },
            set (value) {
                this.$store.commit('graphFilter/UPDATE_NUMBER_OF_PERIODS', value)
                if (this.firstLoad === false) {
                    this.debounceInput()
                } else {
                    this.firstLoad = false
                }
            }
        },
        timePeers: {
            get () {
                return this.$store.state.graphFilter.timePeers
            },
            set (value) {
                this.$store.commit('graphFilter/UPDATE_TIMEPEERS', value)
                this.debounceInput()
            }
        }
    },
    methods: {
        getQueryParameters () {
            for (let param in this.$route.query) {
                if (param === 'store_ids') {
                    this.stores = []
                    let storeIds = this.$route.query[param].split(',')
                    for (let idx in storeIds) {
                        if (storeIds[idx] === '') {
                            storeIds.splice(idx, 1)
                        } else {
                            this.stores.push(parseInt(storeIds[idx]))
                        }
                    }
                    this.storeSelectChange(false)
                    this.$emit('filterChanged')
                } else if (param === 'store_id') {
                    this.stores = [parseInt(this.$route.query[param])]
                    this.storeSelectChange(false)
                    this.$emit('filterChanged')
                } else if (param === 'manager') {
                    let managerIds = this.$route.query[param].split(',')
                    this.managers = []
                    for (let idx in managerIds) {
                        if (managerIds[idx] === '') {
                            managerIds.splice(idx, 1)
                        } else {
                            this.managers.push(this.$store.getters['general/getStoreInterests'].find(x => x.user_id === parseInt(managerIds[idx])))
                        }
                    }
                    this.managerSelectChange(false)
                    this.$emit('filterChanged')
                } else if (param === 'period') {
                    this.period = this.$route.query[param]
                    this.$emit('filterChanged')
                } else if (param === 'numberofperiods') {
                    this.numberOfPeriods = this.$route.query[param]
                    this.$emit('filterChanged')
                } else if (param === 'contract') {
                    if (this.$route.query[param] === 'detail') {
                        this.contractsSwitch = 'Detail'
                    } else {
                        this.contractsSwitch = 'Total'
                    }
                } else if (param === 'peers') {
                    if (this.$route.query[param] === 'true') {
                        this.timePeers = 'Peers'
                    } else {
                        this.timePeers = 'Time'
                    }
                } else if (param === 'productivity') {
                    if (this.$route.query[param] === 'aov') {
                        this.productivitySwitch = 'AOV'
                    } else if (this.$route.query[param] === 'conv') {
                        this.productivitySwitch = 'Conv'
                    } else {
                        this.productivitySwitch = 'ROI'
                    }
                }

                // Delete param from the url
                let query = Object.assign({}, this.$route.query)
                delete query[param]
                this.$router.replace({ query })
            }
        },
        debounceInput: debounce(
            function () {
                this.$emit('filterChanged')
            }, 1000),
        storeSelectChange (event) {
            if (event === false) { // This means the modal is closed, so we want to reload the graphs
                this.$store.dispatch('graphFilter/updateStores', { 'stores': this.stores })
                this.managers = []
                this.$emit('filterChanged')
            }
        },
        managerSelectChange (event) {
            if (event === false) { // This means the modal is closed, so we want to reload the
                let data = []
                for (let m of this.managers) {
                    let stores = this.$store.state.general.storeInterests.find(x => x.user_id === m)['stores']
                    if (stores !== null && stores.length > 0) {
                        data.push(...stores)
                    }
                }
                data = Array.from(new Set(data))
                this.stores = data
                this.$store.dispatch('graphFilter/updateStores', { 'stores': data })
                this.$emit('filterChanged')
            }
        },
        checkSelect (stores) {
            if (stores.includes('all')) {
                this.stores = this.$store.getters['general/getStores'].map(s => s.store_id)
            } else if (stores.includes('none')) {
                this.stores = []
            }
        },
        checkManagerSelect (managers) {
            if (managers.includes('all')) {
                this.managers = this.$store.getters['general/getStoreInterests'].map(s => s.user_id)
            }
        }
    },
    created () {
        let promiseList = [this.$store.dispatch('general/getStores'), this.$store.dispatch('general/getStoreInterests')]
        Promise.all(promiseList).then(response => {
            this.stores = this.$store.state.general.storeInterests.find(x => x.user_id === parseInt(localStorage.getItem('user_id')))['stores']
            this.managers = [parseInt(localStorage.getItem('user_id'))]
            this.$store.dispatch('graphFilter/updateStores', { 'stores': this.stores, 'initialLoad': true }).then(response => {
                this.getQueryParameters()
                if (this.$route.name.includes('workforce') || this.$route.name.includes('graph')) {
                    this.$store.commit('graphFilter/UPDATE_PERIOD', 'quarter')
                    this.loaded = true
                    this.$emit('filterLoaded')
                } else {
                    this.$store.commit('graphFilter/UPDATE_PERIOD', 'week')
                    this.loaded = true
                    this.$emit('filterLoaded')
                }
            })
        })
    }
}
</script>

<style lang="scss">
.graph-filter {
    .el-select {
        width: 220px !important;
    }
    .period-select {
        width: 220px;
    }
    .filter-right {
        text-align: right;
    }
    .filter-left {
        text-align: left;
    }
    .margin-left-xl {
        margin-left: 5px;
    }
    .el-input-number {
        width: 120px;
    }
    @media (max-width: 1200px) {
        .filter-right, .filter-left {
            text-align: center !important;
        }
        .filter-right {
            margin-top: 10px;
        }
        .period-select {
            margin-top: 10px;
            width: 100px;
        }
        .el-input-number {
            width: 220px !important;
        }
        .switch-right {
            margin-top: 10px;
        }
        .margin-left-xl {
            margin-left: 5px;
            margin-top: 10px;
        }
    }
    @media (max-width: 502px) {
        .margin-left-xl {
            margin-left: 0px;

        }
    }
}
</style>
